<template>
  <el-dialog title="选择专属顾问" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <div class="tree_filter">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      </div>
      <el-tree
        class="filter-tree"
        :data="data"
        :props="defaultProps"
        default-expand-all
        :filter-node-method="filterNode"
        ref="tree"
      ></el-tree>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "chooseDepDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      filterText: "",
      data: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1"
                },
                {
                  id: 10,
                  label: "三级 1-1-2"
                }
              ]
            }
          ]
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1"
            },
            {
              id: 6,
              label: "二级 2-2"
            }
          ]
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1"
            },
            {
              id: 8,
              label: "二级 3-2"
            }
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  }
};
</script>

